if (!window.Eurus.loadedScript.has('image-comparison.js')) {
  window.Eurus.loadedScript.add('image-comparison.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xImageComparison', (sectionId, layout) => ({
        looping: false,
        rafId: 0,
        load(e) {
          this.looping = false;
          if (this.rafId) cancelAnimationFrame(this.rafId);
          if (layout == "horizontal") {
            this.$refs.image.style.setProperty('--compare_' + sectionId, e.target.value + '%');
          } else {
            this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, 100 - e.target.value + '%');
          }
        },
        resizeWindow(el) {
          addEventListener("resize", () => {
            this.setMinMaxInput(el, layout);
          });
        },
        disableScroll(el) {
          let isfocus = true;
          window.addEventListener('wheel', () => {
            if (isfocus) {
              el.blur();
              isfocus = false;
            }
          });
        },
        setMinMaxInput(el) {
          el.min = 0;
          el.max = 100;
        },
        animateOnView(el) {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
          }
          this.looping = true;
          el.value = '0';
          if (layout === 'horizontal') {
            this.$refs.image.style.setProperty('--compare_' + sectionId, '0%');
          } else {
            this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, '100%');
          }
          this.playSweep(el, 0, 100);
        },
        playSweep(el, from, to) {
          const totalDuration = 2500;
          let startTime = null;
          const easeInOutSlowEnd = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

          const setCompare = (value) => {
            el.value = value.toFixed(2);
            if (layout === 'horizontal') {
              this.$refs.image.style.setProperty('--compare_' + sectionId, value + '%');
            } else {
              this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, (100 - value) + '%');
            }
          };

          const step = (timestamp) => {
            if (!this.looping) return;
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / totalDuration, 1);
            const value = from + (to - from) * easeInOutSlowEnd(progress);
            setCompare(value);

            if (progress < 1) {
              this.rafId = requestAnimationFrame(step);
              return;
            }

            setCompare(to);
            this.rafId = requestAnimationFrame(() => this.playSweep(el, to, from));
          };

          this.rafId = requestAnimationFrame(step);
        },
        animateValue(el) {
          const targetValue = parseFloat(el.value);
          let currentHorizontalValue = 100;
          let currentVerticalValue = 0;
          const totalDuration = 1000;
          let startTime = null;

          const easeInOutSlowEnd = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

          const step = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const elapsedTime = timestamp - startTime;
            const progress = Math.min(elapsedTime / totalDuration, 1);

            const easedProgress = easeInOutSlowEnd(progress);

            if (layout === "horizontal") {
              currentHorizontalValue = 100 + (targetValue - 100) * easedProgress;
              el.value = currentHorizontalValue.toFixed(2);
              this.$refs.image.style.setProperty('--compare_' + sectionId, currentHorizontalValue + '%');

              if (progress < 1) {
                requestAnimationFrame(step);
              } else {
                el.value = targetValue;
                this.$refs.image.style.setProperty('--compare_' + sectionId, targetValue + '%');
              }
            } else {
              currentVerticalValue = 0 + (targetValue - 0) * easedProgress;
              el.value = currentVerticalValue.toFixed(2);
              this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, currentVerticalValue + '%');

              if (progress < 1) {
                requestAnimationFrame(step);
              } else {
                el.value = targetValue;
                this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, targetValue + '%');
              }
            }
          };

          requestAnimationFrame(step);
        }
      }));
    });
  });
}
